"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
var common_1 = require("../common");
/**
 * Designed to be the main interface for all profile related matters
 */
var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile(id, userName, props) {
        if (props === void 0) { props = {}; }
        var _this = _super.call(this, __assign(__assign({}, Profile.defaultProps(id, userName)), props)) || this;
        if (!props.id) { // @TODO evaluate
            _this.set({ id: undefined }); // Need Firebase/Auth module to set this
        }
        return _this;
    }
    Profile.defaultAvailability = function () {
        var schedules = [];
        return [];
        // m, w, f lunch and after work, saturday/sunday afternoon
        var lunchtime = {
            startTime: {
                h: 11,
                m: 30
            },
            endTime: {
                h: 13,
                m: 30
            }
        };
        var weekend = {
            startTime: {
                h: 11,
                m: 0
            },
            endTime: {
                h: 15,
                m: 0
            }
        };
        schedules.push(__assign(__assign(__assign({}, common_1.Schedule.defaultProps(99999)), lunchtime), { by: {
                weekDay: 'monday'
            } }));
        schedules.push(__assign(__assign(__assign({}, common_1.Schedule.defaultProps(99999)), lunchtime), { by: {
                weekDay: 'wednesday'
            } }));
        schedules.push(__assign(__assign(__assign({}, common_1.Schedule.defaultProps(99999)), lunchtime), { by: {
                weekDay: 'friday'
            } }));
        schedules.push(__assign(__assign(__assign({}, common_1.Schedule.defaultProps(99999)), weekend), { by: {
                weekDay: 'saturday'
            } }));
        schedules.push(__assign(__assign(__assign({}, common_1.Schedule.defaultProps(99999)), weekend), { by: {
                weekDay: 'sunday'
            } }));
        return schedules;
    };
    /**
     * Default Profile Properties
     * @param {string} id - allow user to override @TODO not sure if we want this...
     * @param {string} userName
     * @return {IProfile}
     */
    Profile.defaultProps = function (id, userName) {
        return {
            id: id,
            userName: userName,
            alphaOnboarded: false,
            anonymous: true,
            firstName: '',
            lastName: '',
            middleName: null,
            phone: null,
            img: null,
            email: null,
            environment: 'HOUSE',
            budget: {
                yearlyLimit: 1200,
                currentSpending: 0,
                currency: 'USD',
                cycle: new Date().toISOString()
            },
            preferences: {
                organic: false,
                local: false
            },
            address: {
                name: null,
                line1: null,
                line2: null,
                country: null,
                state: null,
                region: null,
                province: null,
                zip: null
            },
            preferredAvailability: this.defaultAvailability(),
            billingAddress: null,
            payment: null
        };
    };
    Profile.collections = ['dogs', 'inventory'];
    Profile.firebaseTable = 'scout9-profiles';
    return Profile;
}(common_1.AbstractModel));
exports.Profile = Profile;
